import {useCallback} from 'react';
import {useSearchParams} from 'react-router-dom';

const useChangeParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChangeParams = useCallback(
    (params: Record<string, any>) => {
      const newParams = new URLSearchParams(searchParams);
      for (const [key, value] of Object.entries(params)) {
        newParams.set(key, value);
      }
      setSearchParams(newParams);
    },
    [searchParams],
  );
  return {searchParams, handleChangeParams};
};

export default useChangeParams;
